import Vue from 'vue';
import {getProducts} from '@breakmedia/prime-vue-product/src/store/getProducts';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';

export default {
    namespaced: true,
    state: {
        lastViewedProducts: {}
    },
    mutations: {
        SET_LAST_VIEWED_PRODUCTS(state, products) {
            Vue.set(state, 'lastViewedProducts', products ? products : []);
        }
    },
    actions: {
        loadLastViewedProducts({ commit, rootGetters, dispatch }, ids) {
            if (ids && ids.length > 0) {
                const limit = rootGetters['SearchResults/searchConfig']('searchBoxLastViewedProductsAmount');
                if (ids.length > limit) {
                    ids = ids.slice(0, limit);
                }

                getProducts(new Observable(
                    subscriber => subscriber.next({
                        ids,
                    })
                )).pipe(first()).subscribe(products => {
                    commit('SET_LAST_VIEWED_PRODUCTS', products);
                });
            }
        }
    }
};
